import {
    WIDS_REPORT_REQUEST_GET,
    WIDS_REPORT_RESPONSE_GET_SUCCESS,
    WIDS_REPORT_RESPONSE_GET_FAIL,
} from '../../constants/maintenance/widsConstants';

export const widsReportListReducer = (state = { widsReport: {} }, action) => {
	switch (action.type) {
		case WIDS_REPORT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case WIDS_REPORT_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				widsReport: action.payload,
			};
		case WIDS_REPORT_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};